import { Injectable } from '@angular/core';
import { UploadPageSideTranslation } from '@root/assets/constants/backend-translation.constant';

@Injectable({
    providedIn: 'root'
})
export class BackendTranslationService {
    public getUploadPageSideTranslated(pageSide: string): string {
        return UploadPageSideTranslation.has(pageSide) ? UploadPageSideTranslation.get(pageSide) : pageSide;
    }

}
